module.exports = "<div *ngIf=\"rowData.future_fare\" class=\"table-notice sale-starts-soon\">\n  on sale soon\n</div>\n"